module.exports = __webpack_public_path__ + "static/img/qrcode.9b5df41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/huangshan/qrcode.jpg
// module id = JoT0
// module chunks = 71